module.exports = __webpack_public_path__ + "img/horizontal_6_2_7005.49de7f99.png";